import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

// Склеивает классы Tailwind; при конфликте побеждает последний.
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
